/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon, IconButton, Tooltip } from '@material-ui/core';
/* eslint-enable no-unused-vars */

function MTableAction({
  action,
  data,
}) {
  if (typeof action === 'function') {
    action = action(data);
  }

  if(action.hidden) {
    return null;
  }

  const handleOnClick = event => {
    if (action.onClick) {
      action.onClick(event, data);
      event.stopPropagation();
    }
  };

  const icon = typeof action.icon === 'string' ? (
    <Icon {...action.iconProps} fontSize="small">{action.icon}</Icon>
  ) : (
    <action.icon
      {...action.iconProps}
      disabled={action.disabled}
    />
  );

  const button = (
    <span>
      <IconButton
        color="inherit"
        disabled={action.disabled}
        onClick={(event) => handleOnClick(event)}
      >
        {icon}
      </IconButton>
    </span>
  );

  if (action.tooltip) {
    return <Tooltip title={action.tooltip}>{action.noButton ? icon : button}</Tooltip>;
  } else {
    return action.noButton ? icon : button;
  }
}

MTableAction.defaultProps = {
  action: {},
  data: {}
};

MTableAction.propTypes = {
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
};

export default React.memo(MTableAction);
